import { ContactRoleVariant } from '@procureai/constellation/foundation/pai-object/curated-zone/contact';
import { CountryCode } from '@procureai/constellation/foundation/pai-object/curated-zone/location';
import { isEmpty } from 'ramda';

import {
  CuriositySupplierContact,
  CuriositySupplierLocation,
  SupplierAutocompleteContact,
  SupplierAutocompleteLocation,
} from './SupplierAutocomplete.types';

export const supplierAutocompleteHelper = () => {
  return {
    mapContact: (contacts: CuriositySupplierContact[]): SupplierAutocompleteContact | undefined => {
      if (isEmpty(contacts)) {
        return;
      }
      const { id, preferredLanguage, role, ...contact } =
        contacts.find(({ role }) => role === ContactRoleVariant.PRIMARY) ?? contacts[0];

      return {
        ...contact,
        internalId: id,
        language: preferredLanguage,
        role,
      };
    },
    mapLocation: ([firstLocation]: CuriositySupplierLocation[]): SupplierAutocompleteLocation | undefined => {
      if (!firstLocation) {
        return;
      }

      const { id, countryCode, ...location } = firstLocation;

      return {
        ...location,
        internalId: id,
        countryCode: countryCode as CountryCode,
      };
    },
  };
};
